import axios from '../../utils/axios.utils';
import {
  DeploymentStats,
  MachineEcrDeployment,
  EcrDeployment,
  Machine,
  CreateAssignmentRequest,
} from '../model';

export const getDeploymentStats = async (token: string): Promise<DeploymentStats> => {
  const response = await axios.get('api/admin/ecr/deployments/stats', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const getMachineDeployments = async (
  token: string,
  filters?: {
    machine_serial?: string;
    service_name?: string;
    active?: boolean;
    status?: string;
  }
): Promise<{ count: number; results: MachineEcrDeployment[] }> => {
  const params = new URLSearchParams();
  if (filters?.machine_serial) params.append('machine_serial', filters.machine_serial);
  if (filters?.service_name) params.append('service_name', filters.service_name);
  if (filters?.active !== undefined) params.append('active', String(filters.active));
  if (filters?.status) params.append('status', filters.status);

  const response = await axios.get(
    `api/admin/ecr/machine_deployments?${params}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const getEcrDeployments = async (
  token: string,
  filters?: {
    service_name?: string;
    version?: string;
    status?: string;
  }
): Promise<{ count: number; results: EcrDeployment[] }> => {
  const params = new URLSearchParams();
  if (filters?.service_name) params.append('service_name', filters.service_name);
  if (filters?.version) params.append('version', filters.version);
  if (filters?.status) params.append('status', filters.status);

  const response = await axios.get(
    `api/admin/ecr/deployments?${params}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const getMachines = async (token: string): Promise<Machine[]> => {
  const response = await axios.get('api/admin/machines/?use_cloudflare_channel=true', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const createMachineDeployment = async (
  token: string,
  data: CreateAssignmentRequest
): Promise<MachineEcrDeployment> => {
  const response = await axios.post('api/admin/ecr/machine_deployments', data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data as unknown as MachineEcrDeployment;
};

export const cancelMachineDeployment = async (
  token: string,
  deploymentId: number
): Promise<{ success: boolean; message: string }> => {
  const response = await axios.post(
    `api/admin/ecr/machine_deployments/${deploymentId}/cancel`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data as { success: boolean; message: string };
};

export const triggerDeployments = async (token: string): Promise<any> => {
  const response = await axios.post(
    'api/admin/machine/deployments/trigger',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};
